// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file cluster/cluster.proto (package lvdr.v2.cluster, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cluster/cluster.proto.
 */
export const file_cluster_cluster: GenFile = /*@__PURE__*/
  fileDesc("ChVjbHVzdGVyL2NsdXN0ZXIucHJvdG8SD2x2ZHIudjIuY2x1c3RlciJSCg9TZXNzaW9uUmVkaXJlY3QSFwoPdGFyZ2V0X2luc3RhbmNlGAEgASgJEg4KBnJlYXNvbhgCIAEoCRIWCg5yZXRyeV9hZnRlcl9tcxgDIAEoBSJVCgtEcmFpbk5vdGljZRIPCgdtZXNzYWdlGAEgASgJEhcKD2FjdGl2ZV9yZXNlYXJjaBgCIAEoBRIcChRuZXdfcmVzZWFyY2hfYmxvY2tlZBgDIAEoCCIzChFTZXNzaW9uTW92ZWRGcmFtZRIOCgZ0YXJnZXQYASABKAkSDgoGcmVhc29uGAIgASgJQihaJmdpdGh1Yi5jb20vZ3ZzNDIvbHZkci9wcm90by92Mi9jbHVzdGVyYgZwcm90bzM");

/**
 * SessionRedirect tells the client to reconnect to a different instance.
 *
 * @generated from message lvdr.v2.cluster.SessionRedirect
 */
export type SessionRedirect = Message<"lvdr.v2.cluster.SessionRedirect"> & {
  /**
   * @generated from field: string target_instance = 1;
   */
  targetInstance: string;

  /**
   * "placement" | "drain" | "rebalance"
   *
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * suggested delay before reconnect (default 500)
   *
   * @generated from field: int32 retry_after_ms = 3;
   */
  retryAfterMs: number;
};

/**
 * Describes the message lvdr.v2.cluster.SessionRedirect.
 * Use `create(SessionRedirectSchema)` to create a new message.
 */
export const SessionRedirectSchema: GenMessage<SessionRedirect> = /*@__PURE__*/
  messageDesc(file_cluster_cluster, 0);

/**
 * DrainNotice informs the client about instance maintenance.
 *
 * @generated from message lvdr.v2.cluster.DrainNotice
 */
export type DrainNotice = Message<"lvdr.v2.cluster.DrainNotice"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;

  /**
   * @generated from field: int32 active_research = 2;
   */
  activeResearch: number;

  /**
   * @generated from field: bool new_research_blocked = 3;
   */
  newResearchBlocked: boolean;
};

/**
 * Describes the message lvdr.v2.cluster.DrainNotice.
 * Use `create(DrainNoticeSchema)` to create a new message.
 */
export const DrainNoticeSchema: GenMessage<DrainNotice> = /*@__PURE__*/
  messageDesc(file_cluster_cluster, 1);

/**
 * SessionMovedFrame instructs the FE that the user's session must reconnect
 * to a different backend. Sent by a backend that received a WS connection
 * for a user whose lease is held by another peer; the FE caches the target
 * and reconnects there. Sent immediately before the WS is closed with
 * code 4001 ("session reassigned"). Distinct from SessionRedirect (Traefik
 * cookie-based) — this carries an explicit `?b=<id>` query target that
 * pins the reconnect to the lease-owning backend.
 *
 * @generated from message lvdr.v2.cluster.SessionMovedFrame
 */
export type SessionMovedFrame = Message<"lvdr.v2.cluster.SessionMovedFrame"> & {
  /**
   * target is the full wss:// URL the FE should reconnect to.
   * Includes the backend hint (e.g. wss://lvdr.com/ws/v2?b=3) so Traefik
   * routes the reconnect to the right backend.
   *
   * @generated from field: string target = 1;
   */
  target: string;

  /**
   * reason is a short human-readable explanation, useful for logs +
   * optional UI display. Examples: "lease_owned_by_peer", "drained_takeover".
   *
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message lvdr.v2.cluster.SessionMovedFrame.
 * Use `create(SessionMovedFrameSchema)` to create a new message.
 */
export const SessionMovedFrameSchema: GenMessage<SessionMovedFrame> = /*@__PURE__*/
  messageDesc(file_cluster_cluster, 2);

